/**
 * Build variants of the native app. Each one gets its own application id, URL
 * scheme and launcher icon so that several variants can be installed side by
 * side on the same device.
 *
 * Self-contained on purpose: `apps/front/app.config.ts` and the icon generation
 * script load its compiled `dist/constants/app-variants.js` with plain Node,
 * outside of any bundler, so it must not import anything.
 */
export const APP_VARIANTS = ['development', 'preview', 'production'];
export const DEFAULT_APP_VARIANT = 'production';
export const APP_VARIANT_CONFIG = {
    development: {
        idSuffix: 'dev',
        nameSuffix: ' Dev',
        badge: { label: 'DEV', color: '#7C3AED' },
    },
    preview: {
        idSuffix: 'preview',
        nameSuffix: ' Preview',
        badge: { label: 'PREV', color: '#0F766E' },
    },
    production: {
        idSuffix: '',
        nameSuffix: '',
        badge: null,
    },
};
export const APP_BASE_ID = 'fr.familychef';
export const APP_BASE_SCHEME = 'familychef';
/** Falls back on the store build for an unset or unknown value. */
export function resolveAppVariant(value) {
    return APP_VARIANTS.find((variant) => variant === value) ?? DEFAULT_APP_VARIANT;
}
/** `fr.familychef`, `fr.familychef.dev`, … */
export function getAppId(variant) {
    const { idSuffix } = APP_VARIANT_CONFIG[variant];
    return idSuffix ? `${APP_BASE_ID}.${idSuffix}` : APP_BASE_ID;
}
/** `familychef`, `familychef-dev`, … */
export function getAppScheme(variant) {
    const { idSuffix } = APP_VARIANT_CONFIG[variant];
    return idSuffix ? `${APP_BASE_SCHEME}-${idSuffix}` : APP_BASE_SCHEME;
}
//# sourceMappingURL=app-variants.js.map